import * as yup from 'yup';

export const playerComplaintSchema = yup.object({
  status: yup.string().required('Estado es requerido'),
});